module.exports = __webpack_public_path__ + "img/img (34).3c682dca.png";